import DefaultLayout from "../../components/Layout/DefaultLayout";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useMail} from "../../context/MailboxContext";
import {Link, Outlet, useSearchParams} from "react-router-dom";
import ListBottomPager from "../../components/ListBottomPager";
import {Controller, useForm} from "react-hook-form";
import DatePicker from "react-date-picker";
import {Form} from "react-bootstrap";


const ListMail = ({urlParam, pageTitle}) => {
    const { t } = useTranslation();
    const [, setSuccessMessage] = useState(null)
    const {mails, metaData, fetchAll} = useMail()
    const [, setListParams] = useState(null)
    const [searchParams, setSearchParams] = useSearchParams();

    const {
        register,
        formState: { errors: formErrors },
        control,
        setValue,
    } = useForm({})

    useEffect(() => {
        const date = searchParams.get('date');
        const page = searchParams.get('page');
        if (date) {
            const dateParts = date.split("-");
            setValue('date', new Date(Number(dateParts[2]), Number(dateParts[1]) - 1, Number(dateParts[0])))
        }
        if (page) {
            setValue('page', page)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    useEffect(() => {
        const page = searchParams.get('page');
        const date = searchParams.get('date');

        let params = []
        if (urlParam) {
            for (var p in urlParam) {
                params[p] = urlParam[p]
            }
        }

        if (page) {
            params['page'] = page
        }

        if (date) {
            params['date'] = date
        }

        if (Object.keys(params).length > 0) {
            const listParamsString = Object.keys(params).map((key) => {
                return (`${key}=${params[key]}`)
            }).join('&')

            setListParams(listParamsString)
        } else {
            setListParams(null)
        }

        fetchAll(params)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchParams]);

    const handlePage = (page) => {
        setSearchParams(searchParams => {
            if (page === undefined || page === null) {
                searchParams.delete('page')
            } else {
                searchParams.set('page', page);
            }

            return searchParams;
        });
    }

    const handleDate = (event) => {
        const {name, value} = event?.target;
        setSearchParams(searchParams => {
            if (value === undefined || value === null) {
                searchParams.delete(name)
            } else {
                const stringDate = value.toLocaleDateString("fr").replaceAll('/', '-')
                searchParams.set(name, stringDate);
            }
            searchParams.set('page', '1');

            return searchParams;
        });
    }

    const handleQuery = (event) => {
        const {value} = event?.target;
        console.log(value)
        // setSearchParams(searchParams => {
        //     if (value === undefined || value === null) {
        //         searchParams.delete(name)
        //     } else {
        //         const stringDate = value.toLocaleDateString("fr").replaceAll('/', '-')
        //         searchParams.set(name, stringDate);
        //     }
        //     searchParams.set('page', '1');
        //
        //     return searchParams;
        // });
    }

    return (
        <DefaultLayout>
            <h1 className="h3 mb-3">{t(pageTitle)}</h1>

            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header">

                            <div className="row">
                                <div className="col-sm-12 col-md-3">
                                    <Form.Control
                                        type="text"
                                        placeholder="Recherche factures TP"
                                        size="lg"
                                        {...register("query", {
                                            onChange: (event) => handleQuery(event),
                                        })}
                                    />
                                </div>
                                <div className="col-sm-12 col-md-3">
                                    <Controller
                                        name="date"
                                        control={control}
                                        render={({field, value, name, ref}) => (
                                            <DatePicker
                                                onChange={field.onChange}
                                                value={field.value}
                                                className={`p-0 form-control form-control-lg ${formErrors && formErrors.date ? ' is-invalid' : ''}`}
                                                format={"dd-MM-y"}
                                            />
                                        )
                                        }
                                        size="lg"
                                        {...register("date", {
                                            onChange: (event) => handleDate(event),
                                        })}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="dataTables_wrapper dt-bootstrap5 no-footer">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="table-responsive">
                                            <table className="table table-hover table-striped">
                                                <thead>
                                                <tr>
                                                    <th scope="col">{t('mailbox.mail.list.subject')}</th>
                                                    <th scope="col">{t('mailbox.mail.list.invoiceNumber')}</th>
                                                    <th scope="col">{t('mailbox.mail.list.sent_at')}</th>
                                                    <th>Actions</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {mails && Object.keys(mails).map(key => (
                                                    <tr
                                                        key={key}
                                                    >
                                                        <td>{mails[key][0].subject}</td>
                                                        <td>{mails[key][0].tiersPayant?.invoiceNumber}</td>
                                                        <td>{mails[key][0].sentAt}</td>
                                                        <td>
                                                            <Link
                                                                to={`/mailbox/received/show/${mails[key][0].id}`}
                                                            >
                                                                Gérer le dossier
                                                            </Link>
                                                        </td>
                                                    </tr>
                                                ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <ListBottomPager metaData={metaData} handlePage={handlePage}/>
                            </div>
                        </div>
                    </div>
                </div>
                <Outlet
                    context={{setSuccessMessage}}
                />
            </div>
        </DefaultLayout>
    )
}

export default ListMail